<template>
<div class="ResumeEdit">
    <div class="personal_info_box" v-show="!(isEdit && editFromNo === 1)">
        <div class="info_left_div">
            <img v-if="resumeData.baseinfo.sex === 2" :src="resumeData.baseinfo.customericonurl.furl === '' ? require('@/common/images/talentsimg/default_user2.png') : resumeData.baseinfo.customericonurl.furl" alt="">
            <img v-else :src="resumeData.baseinfo.customericonurl.furl === '' ? require('@/common/images/talentsimg/default_user.png') : resumeData.baseinfo.customericonurl.furl" alt="">
            <div v-if="resumeData.baseinfo.name === '' || !resumeData.baseinfo.name" class="info_div">
                <p>未填写</p>
                <div>
                    <img :src="require('@/common/images/talentsimg/bicon1.png')" alt="">
                    <span>未填写</span>
                </div>
                <div>
                    <img :src="require('@/common/images/talentsimg/bicon2.png')" alt="">
                    <span>未填写</span>
                </div>
                <div class="contact_info_div">
                    <img :src="require('@/common/images/talentsimg/bicon3.png')" alt="">
                    <span>未填写</span>
                    <img :src="require('@/common/images/talentsimg/bicon4.png')" alt="">
                    <span>未填写</span>
                </div>
            </div>
            <div v-else class="info_div">
                <p>{{resumeData.baseinfo.name}}</p>
                <div>
                    <img :src="require('@/common/images/talentsimg/bicon1.png')" alt="">
                    <span>{{resumeData.baseinfo.sexname}}</span>
                    <span>{{resumeData.baseinfo.birth}}</span>
                    <span>{{resumeData.baseinfo.nativeplace}}</span>
                    <span>{{resumeData.baseinfo.edutypename}}</span>
                </div>
                <div>
                    <img :src="require('@/common/images/talentsimg/bicon2.png')" alt="">
                    <span>{{resumeData.baseinfo.exptypename}}</span>
                    <span>{{resumeData.baseinfo.jobstatusname}}</span>
                    <span>目前年薪{{resumeData.baseinfo.currentsalary}}万</span>
                </div>
                <div class="contact_info_div">
                    <img :src="require('@/common/images/talentsimg/bicon3.png')" alt="">
                    <span>{{resumeData.baseinfo.mobileno}}</span>
                    <img :src="require('@/common/images/talentsimg/bicon4.png')" alt="">
                    <span>{{resumeData.baseinfo.email}}</span>
                </div>
            </div>
        </div>
        <div class="info_right_div">
            <div class="edit_div" @click="editClick(1)" v-show="!isEdit">
                <img :src="require('@/common/images/talentsimg/aicon_edit.png')" alt="">
                <span>编辑</span>
            </div>
            <div class="edit_div gray_style" v-show="isEdit">
                <img :src="require('@/common/images/talentsimg/aicon_edit2.png')" alt="">
                <span>编辑</span>
            </div>
        </div>
    </div>
    <div class="personal_info_form_box" v-show="isEdit && editFromNo === 1">
        <div class="personal_info_div">
            <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
            <div class="form_div">
                <div class="form_item_div">
                    <div>
                        <p><span>* </span> 姓名</p>
                        <el-input v-model="userFromData.name" placeholder="填写姓名"></el-input>
                    </div>
                    <div>
                        <p><span>* </span> 性别</p>
                        <el-select v-model="userFromData.sex" placeholder="选择性别">
                            <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_item_div">
                    <div>
                        <p><span>* </span> 出生日期</p>
                        <el-date-picker v-model="userFromData.birth" type="date" value-format="yyyy-MM-dd" placeholder="选择出生日期"></el-date-picker>
                    </div>
                    <div>
                        <p><span>* </span> 居住地址</p>
                        <el-input v-model="userFromData.domplace" placeholder="填写居住地"></el-input>
                    </div>
                </div>
                <div class="form_item_div">
                    <div>
                        <p><span>* </span> 籍贯</p>
                        <el-input v-model="userFromData.nativeplace" placeholder="填写籍贯"></el-input>
                    </div>
                </div>
                <div class="form_item_div">
                    <div>
                        <p><span>* </span> 手机号码</p>
                        <el-input v-model="userFromData.mobileno" placeholder="填写手机号" maxlength="11"></el-input>
                    </div>
                    <div>
                        <p><span>* </span> 电子邮箱</p>
                        <el-input v-model="userFromData.email" placeholder="填写邮箱"></el-input>
                    </div>
                </div>
                <div class="form_item_div">
                    <div>
                        <p><span>* </span> 学历</p>
                        <el-select v-model="userFromData.edutype" placeholder="选择学历">
                            <el-option v-for="item in educationOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div>
                        <p><span>* </span> 工作年限</p>
                        <el-select v-model="userFromData.exptype" placeholder="选择年限">
                            <el-option v-for="item in workYearsOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_item_div">
                    <div>
                        <p><span>* </span> 工作状态</p>
                        <el-select v-model="userFromData.jobstatus" placeholder="选择状态">
                            <el-option v-for="item in workStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div class="suffix_input_box">
                        <p><span>* </span> 目前年薪</p>
                        <el-input v-model="userFromData.currentsalary"><span slot="suffix" class="el-input__icon">万/年</span></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn_div">
            <el-button type="primary" @click="userInfoEditSureBtn" size="small">确定</el-button>
            <el-button plain size="small" @click="editCancelBtn(1)">取消</el-button>
        </div>
    </div>
    <div class="resume_item_box">
        <div class="title_box">
            <div class="title_left_box">
                <img :src="require('@/common/images/talentsimg/cicon1.png')" alt="">
                <span>求职意向</span>
            </div>
            <div class="title_right_box" @click="editClick(2)" v-show="!isEdit && resumeData.fullrate > 0">
                <img :src="require('@/common/images/talentsimg/aicon_edit.png')" alt="">
                <span>编辑</span>
            </div>
            <div class="title_right_box gray_style" v-show="isEdit || resumeData.fullrate === 0">
                <img :src="require('@/common/images/talentsimg/aicon_edit2.png')" alt="">
                <span>编辑</span>
            </div>
        </div>
        <div class="Job_Intension_edit_box" v-show="isEdit && editFromNo === 2">
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 期望行业</p>
                <el-input v-model="objectiveFromData.wishindustry" placeholder="请填写期望行业，最多10个字。 " maxlength="10"></el-input>
            </div>
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 期望职位</p>
                <el-input v-model="objectiveFromData.wishjobname" placeholder="请填写期望职位，最多10个字。 " maxlength="10"></el-input>
            </div>
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 期望地点</p>
                <el-select style="width: 100%;" v-model="objectiveFromData.wishplace" placeholder="选择期望地点">
                    <el-option v-for="item in placeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="Job_Intension_edit_row suffix_input_box">
                <p><span>* </span>期望年薪</p>
                <el-input v-model="objectiveFromData.wishsalary" placeholder="最少年薪"><span slot="suffix" class="el-input__icon">万/年</span></el-input>
                <label>至</label>
                <el-input v-model="objectiveFromData.wishsalarymax" placeholder="最多年薪"><span slot="suffix" class="el-input__icon">万/年</span></el-input>
            </div>
            <div class="btn_div">
                <el-button type="primary" @click="objectiveSureBtn" size="small">确定</el-button>
                <el-button plain size="small" @click="editCancelBtn">取消</el-button>
            </div>
        </div>
        <div class="Job_Intension_info_box" v-show="!(isEdit && editFromNo === 2)">
            <div class="Job_Intension_row_div">
                <label>期望行业：</label>
                <span>{{resumeData.baseinfo.wishindustry}}</span>
            </div>
            <div class="Job_Intension_row_div">
                <label>期望职位：</label>
                <span>{{resumeData.baseinfo.wishjobname}}</span>
            </div>
            <div class="Job_Intension_row_div">
                <label>期望地点：</label>
                <span>{{resumeData.baseinfo.wishplace}}</span>
            </div>
            <div class="Job_Intension_row_div">
                <label>期望年薪：</label>
                <span v-if="resumeData.baseinfo.wishsalary === 0 && resumeData.baseinfo.wishsalarymax === 0 && resumeData.baseinfo.wishindustry !== ''">面议</span>
                <span v-if="resumeData.baseinfo.wishsalary !== 0 || resumeData.baseinfo.wishsalarymax !== 0">{{resumeData.baseinfo.wishsalary}}-{{resumeData.baseinfo.wishsalarymax}}万/年</span>
                <span v-if="resumeData.baseinfo.wishindustry === ''"></span>
            </div>
        </div>
    </div>
    <div class="resume_item_box">
        <div class="title_box">
            <div class="title_left_box">
                <img :src="require('@/common/images/talentsimg/cicon2.png')" alt="">
                <span>工作经历</span>
            </div>
            <div class="title_right_box" @click="editClick(3)" v-show="!isEdit && resumeData.fullrate > 0">
                <img :src="require('@/common/images/talentsimg/aicon_add.png')" alt="">
                <span>添加</span>
            </div>
            <div class="title_right_box gray_style" v-show="isEdit || resumeData.fullrate === 0">
                <img :src="require('@/common/images/talentsimg/aicon_add2.png')" alt="">
                <span>添加</span>
            </div>
        </div>
        <div style="margin-bottom: 20px;" class="Job_Intension_edit_box" v-show="isEdit && editFromNo === 3">
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 公司名称</p>
                <el-input v-model="workExperienceForm.companyname" placeholder="请填写公司名称，最多20个字。" maxlength="20"></el-input>
            </div>
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 所在行业</p>
                <el-input v-model="workExperienceForm.industryname" placeholder="请填写所在行业，最多10个字。" maxlength="10"></el-input>
            </div>
            <div class="Job_Intension_edit_row suffix_input_box">
                <p><span>* </span> 任职时间</p>
                <el-date-picker v-model="workExperienceForm.jobbegin" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                <label>至</label>
                <el-date-picker v-if="!workExperienceForm.istoday" v-model="workExperienceForm.jobend" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                <el-checkbox @change="workEndTimeChange" v-model="workExperienceForm.istoday">至今</el-checkbox>
            </div>
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 岗位名称</p>
                <el-input style="width: 270px;" v-model="workExperienceForm.jobname" placeholder="请填写岗位名称，最多10个字。" maxlength="10"></el-input>
            </div>
            <div class="Job_Intension_edit_row textarea_input_div">
                <p>岗位业绩</p>
                <el-input type="textarea" :rows="4" placeholder="请填写岗位业绩，最多300个字。" v-model="workExperienceForm.jobinfo" maxlength="300"></el-input>
            </div>
            <div class="btn_div">
                <el-button type="primary" @click="workExperienceSureBtn" size="small">确定</el-button>
                <el-button plain size="small" @click="editCancelBtn(3)">取消</el-button>
            </div>
        </div>
        <div class="occupational_history_box">
            <div class="occupational_history_item_box" v-for="(item, index) in resumeData.conpanyinfolist" :key="index">
                <div class="content_div" v-show="!item.isEdit">
                    <div class="handle_box occupational_history_item_row_div">
                        <div class="time_info">{{item.jobbegin2}}-{{item.istoday ? '至今' : item.jobend2}}</div>
                        <div class="handle_div" v-show="!isEdit">
                            <div @click="editWorkExperience(item)">
                                <img :src="require('@/common/images/talentsimg/aicon_edit.png')" alt="">
                                <span>编辑</span>
                            </div>
                            <div @click="delWorkExperience(item)">
                                <img :src="require('@/common/images/talentsimg/aicon_del.png')" alt="">
                                <span>删除</span>
                            </div>
                        </div>
                        <div class="handle_div gray_div" v-show="isEdit">
                            <div>
                                <img :src="require('@/common/images/talentsimg/aicon_edit2.png')" alt="">
                                <span>编辑</span>
                            </div>
                            <div>
                                <img :src="require('@/common/images/talentsimg/aicon_del2.png')" alt="">
                                <span>删除</span>
                            </div>
                        </div>
                    </div>
                    <div class="company_name_text occupational_history_item_row_div">{{item.companyname}}</div>
                    <div class="job_info_div occupational_history_item_row_div">
                        <span>{{item.industryname}}</span>
                        <span>{{item.jobname}}</span>
                    </div>
                    <div class="job_desc_div occupational_history_item_row_div">{{item.jobinfo}}</div>
                </div>
                <div class="Job_Intension_edit_box" v-show="item.isEdit">
                    <div class="Job_Intension_edit_row">
                        <p><span>* </span> 公司名称</p>
                        <el-input v-model="workExperienceForm.companyname" placeholder="请填写公司名称，最多20个字。" maxlength="20"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row">
                        <p><span>* </span> 所在行业</p>
                        <el-input v-model="workExperienceForm.industryname" placeholder="请填写所在行业，最多10个字。" maxlength="10"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row suffix_input_box">
                        <p><span>* </span> 任职时间</p>
                        <el-date-picker v-model="workExperienceForm.jobbegin" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                        <label>至</label>
                        <el-date-picker v-if="!workExperienceForm.istoday" v-model="workExperienceForm.jobend" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                        <el-checkbox @change="workEndTimeChange" v-model="workExperienceForm.istoday">至今</el-checkbox>
                    </div>
                    <div class="Job_Intension_edit_row">
                        <p><span>* </span> 岗位名称</p>
                        <el-input style="width: 270px;" v-model="workExperienceForm.jobname" placeholder="请填写岗位名称，最多10个字。" maxlength="10"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row textarea_input_div">
                        <p>岗位业绩</p>
                        <el-input type="textarea" :rows="4" placeholder="请填写岗位业绩，最多300个字。" v-model="workExperienceForm.jobinfo" maxlength="300"></el-input>
                    </div>
                    <div class="btn_div">
                        <el-button type="primary" @click="workExperienceSureBtn" size="small">确定</el-button>
                        <el-button plain size="small" @click="cancelEditWorkExperience(item)">取消</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="resume_item_box">
        <div class="title_box">
            <div class="title_left_box">
                <img :src="require('@/common/images/talentsimg/cicon3.png')" alt="">
                <span>项目经历</span>
            </div>
            <div class="title_right_box" @click="editClick(4)" v-show="!isEdit && resumeData.fullrate > 0">
                <img :src="require('@/common/images/talentsimg/aicon_add.png')" alt="">
                <span>添加</span>
            </div>
            <div class="title_right_box gray_style" v-show="isEdit || resumeData.fullrate === 0">
                <img :src="require('@/common/images/talentsimg/aicon_add2.png')" alt="">
                <span>添加</span>
            </div>
        </div>
        <div style="margin-bottom: 20px;" class="Job_Intension_edit_box" v-show="isEdit && editFromNo === 4">
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 项目名称</p>
                <el-input v-model="projectFormData.projectname" placeholder="请填写项目名称，最多20个字。" maxlength="20"></el-input>
            </div>
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 担任职务</p>
                <el-input v-model="projectFormData.dutyname" placeholder="请填写担任职务，最多10个字。" maxlength="10"></el-input>
            </div>
            <div class="Job_Intension_edit_row suffix_input_box">
                <p><span>* </span> 项目时间</p>
                <el-date-picker v-model="projectFormData.projectbegin" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                <label>至</label>
                <el-date-picker v-if="!projectFormData.istoday" v-model="projectFormData.projectend" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                <el-checkbox @change="projectEndTimeChange" v-model="projectFormData.istoday">至今</el-checkbox>
            </div>
            <div class="Job_Intension_edit_row textarea_input_div">
                <p><span>* </span> 项目职责</p>
                <el-input type="textarea" :rows="4" placeholder="请填写项目职责，最多300个字。" v-model="projectFormData.projectduty" maxlength="300"></el-input>
            </div>
            <div class="Job_Intension_edit_row textarea_input_div">
                <p>项目业绩</p>
                <el-input type="textarea" :rows="4" placeholder="请填写项目业绩，最多300个字。" v-model="projectFormData.projectexpinfo" maxlength="300"></el-input>
            </div>
            <div class="Job_Intension_edit_row textarea_input_div">
                <p><span>* </span> 项目描述</p>
                <el-input type="textarea" :rows="4" placeholder="请填写项目描述，最多300个字。" v-model="projectFormData.projectinfo" maxlength="300"></el-input>
            </div>
            <div class="btn_div">
                <el-button type="primary" @click="projectEditSureBtn" size="small">确定</el-button>
                <el-button plain size="small" @click="editCancelBtn(4)">取消</el-button>
            </div>
        </div>
        <div class="Project_experience_box">
            <div class="Project_experience_item_box" v-for="(item, index) in resumeData.projectinfolist" :key="index">
                <div class="content_div" v-show="!item.isEdit">
                    <div class="handle_box Project_experience_item_row_div">
                        <div class="time_info">{{item.projectbegin2}}-{{item.istoday ? '至今' : item.projectend2}}</div>
                        <div class="handle_div" v-show="!isEdit">
                            <div @click="editProjectEdit(item)">
                                <img :src="require('@/common/images/talentsimg/aicon_edit.png')" alt="">
                                <span>编辑</span>
                            </div>
                            <div  @click="delProjectEdit(item)">
                                <img :src="require('@/common/images/talentsimg/aicon_del.png')" alt="">
                                <span>删除</span>
                            </div>
                        </div>
                        <div class="handle_div gray_div" v-show="isEdit">
                            <div>
                                <img :src="require('@/common/images/talentsimg/aicon_edit2.png')" alt="">
                                <span>编辑</span>
                            </div>
                            <div>
                                <img :src="require('@/common/images/talentsimg/aicon_del2.png')" alt="">
                                <span>删除</span>
                            </div>
                        </div>
                    </div>
                    <div class="company_name_text Project_experience_item_row_div">{{item.projectname}}</div>
                    <div class="Project_experience_item_row_div">{{item.dutyname}}</div>
                    <div class="Project_desc_row_div Project_experience_item_row_div">
                        <p>项目职责：</p>
                        <p class="p_desc_text">{{item.projectduty}}</p>
                    </div>
                    <div v-if="item.projectexpinfo !== ''" class="Project_desc_row_div Project_experience_item_row_div">
                        <p>项目业绩：</p>
                        <p class="p_desc_text">{{item.projectexpinfo}}</p>
                    </div>
                    <div class="Project_desc_row_div Project_experience_item_row_div">
                        <p>项目描述：</p>
                        <p class="p_desc_text2">{{item.projectinfo}}</p>
                    </div>
                </div>
                <div class="Job_Intension_edit_box" v-show="item.isEdit">
                    <div class="Job_Intension_edit_row">
                        <p><span>* </span> 项目名称</p>
                        <el-input v-model="projectFormData.projectname" placeholder="请填写项目名称，最多20个字。" maxlength="20"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row">
                        <p><span>* </span> 担任职务</p>
                        <el-input v-model="projectFormData.dutyname" placeholder="请填写担任职务，最多10个字。" maxlength="10"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row suffix_input_box">
                        <p><span>* </span> 项目时间</p>
                        <el-date-picker v-model="projectFormData.projectbegin" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                        <label>至</label>
                        <el-date-picker v-if="!projectFormData.istoday" v-model="projectFormData.projectend" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                        <el-checkbox @change="projectEndTimeChange" v-model="projectFormData.istoday">至今</el-checkbox>
                    </div>
                    <div class="Job_Intension_edit_row textarea_input_div">
                        <p><span>* </span> 项目职责</p>
                        <el-input type="textarea" :rows="4" placeholder="请填写项目职责，最多300个字。" v-model="projectFormData.projectduty" maxlength="300"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row textarea_input_div">
                        <p>项目业绩</p>
                        <el-input type="textarea" :rows="4" placeholder="请填写项目业绩，最多300个字。" v-model="projectFormData.projectexpinfo" maxlength="300"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row textarea_input_div">
                        <p><span>* </span> 项目描述</p>
                        <el-input type="textarea" :rows="4" placeholder="请填写项目描述，最多300个字。" v-model="projectFormData.projectinfo" maxlength="300"></el-input>
                    </div>
                    <div class="btn_div">
                        <el-button type="primary" @click="projectEditSureBtn" size="small">确定</el-button>
                        <el-button plain size="small" @click="cancelEditProject(item)">取消</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="resume_item_box">
        <div class="title_box">
            <div class="title_left_box">
                <img :src="require('@/common/images/talentsimg/cicon4.png')" alt="">
                <span>教育经历</span>
            </div>
            <div class="title_right_box" @click="editClick(5)" v-show="!isEdit && resumeData.fullrate > 0">
                <img :src="require('@/common/images/talentsimg/aicon_add.png')" alt="">
                <span>添加</span>
            </div>
            <div class="title_right_box gray_style" v-show="isEdit || resumeData.fullrate === 0">
                <img :src="require('@/common/images/talentsimg/aicon_add2.png')" alt="">
                <span>添加</span>
            </div>
        </div>
        <div style="margin-bottom: 20px;" class="Job_Intension_edit_box" v-show="isEdit && editFromNo === 5">
            <div class="Job_Intension_edit_row suffix_input_box">
                <p><span>* </span> 就读时间</p>
                <el-date-picker v-model="eduFormData.edubegin" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                <label>至</label>
                <el-date-picker v-if="!eduFormData.istoday" v-model="eduFormData.eduend" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                <el-checkbox @change="eduEndTimeChange" v-model="eduFormData.istoday">至今</el-checkbox>
            </div>
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 学校名称</p>
                <el-input v-model="eduFormData.eduname" placeholder="请填写学校名称，最多20个字。" maxlength="20"></el-input>
            </div>
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 专业名称</p>
                <el-input v-model="eduFormData.majorname" placeholder="请填写专业名称，最多10个字。" maxlength="10"></el-input>
            </div>
            <div class="Job_Intension_edit_row">
                <p><span>* </span> 学历证书</p>
                <el-select style="width: 100%;" v-model="eduFormData.edulevel" placeholder="请选择学历证书">
                    <el-option v-for="item in educationOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="Job_Intension_edit_row certificate_box">
                <p>证书照片</p>
                <div class="certificate_div">
                    <div class="certificate_img_box" v-for="(imgItem, i) in eduFormData.eduimageinfp" :key="i">
                        <img class="del_img" @click="delImg(i)" :src="require('@/common/images/talentsimg/del_icon.png')" alt="">
                        <img class="certificate_img" :src="imgItem.furl" alt="">
                    </div>
                    <Upload2 v-if="eduFormData.eduimageinfp.length < 5" class="avatar-uploader" :imgRule="imgRule"  @setImage="setCCoverfile2" :uploadType="uploadType" ref="coverfile2"></Upload2>
                </div>
            </div>
            <div class="btn_div">
                <el-button type="primary" @click="eduInfoEditSureBtn" size="small">确定</el-button>
                <el-button plain size="small" @click="editCancelBtn">取消</el-button>
            </div>
        </div>
        <div class="edu_experience_box">
            <div class="edu_experience_item_box" v-for="(item, index) in resumeData.eduinfolist" :key="index">
                <div class="content_div" v-show="!item.isEdit">
                    <div class="edu_time edu_row_div">{{item.edubegin2}}-{{item.istoday ? '至今' : item.eduend2}}</div>
                    <div class="school_name edu_row_div">{{item.eduname}}</div>
                    <div class="profession_name edu_row_div">{{item.majorname}}</div>
                    <div class="education_background edu_row_div">{{item.edulevelname}}</div>
                    <div class="handle_div" v-show="!isEdit">
                        <div @click="eduEdit(item)">
                            <img :src="require('@/common/images/talentsimg/aicon_edit.png')" alt="">
                            <span>编辑</span>
                        </div>
                        <div  @click="delEdit(item)">
                            <img :src="require('@/common/images/talentsimg/aicon_del.png')" alt="">
                            <span>删除</span>
                        </div>
                    </div>
                    <div class="handle_div gray_div" v-show="isEdit">
                        <div>
                            <img :src="require('@/common/images/talentsimg/aicon_edit2.png')" alt="">
                            <span>编辑</span>
                        </div>
                        <div>
                            <img :src="require('@/common/images/talentsimg/aicon_del2.png')" alt="">
                            <span>删除</span>
                        </div>
                    </div>
                </div>
                <div class="Job_Intension_edit_box" v-show="item.isEdit">
                    <div class="Job_Intension_edit_row suffix_input_box">
                        <p><span>* </span> 就读时间</p>
                        <el-date-picker v-model="eduFormData.edubegin" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                        <label>至</label>
                        <el-date-picker v-if="!eduFormData.istoday" v-model="eduFormData.eduend" style="width: 270px;" type="month" format="yyyy-MM" value-format="yyyyMM" placeholder="请选择时间"></el-date-picker>
                        <el-checkbox @change="eduEndTimeChange" v-model="eduFormData.istoday">至今</el-checkbox>
                    </div>
                    <div class="Job_Intension_edit_row">
                        <p><span>* </span> 学校名称</p>
                        <el-input v-model="eduFormData.eduname" placeholder="请填写学校名称，最多20个字。" maxlength="20"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row">
                        <p><span>* </span> 专业名称</p>
                        <el-input v-model="eduFormData.majorname" placeholder="请填写专业名称，最多10个字。" maxlength="10"></el-input>
                    </div>
                    <div class="Job_Intension_edit_row">
                        <p><span>* </span> 学历证书</p>
                        <el-select style="width: 100%;" v-model="eduFormData.edulevel" placeholder="请选择学历证书">
                            <el-option v-for="item in educationOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div class="Job_Intension_edit_row certificate_box">
                        <p>证书照片</p>
                        <div class="certificate_div">
                            <div class="certificate_img_box" v-for="(imgItem, i) in eduFormData.eduimageinfp" :key="i">
                                <img class="del_img" @click="delImg(i)" :src="require('@/common/images/talentsimg/del_icon.png')" alt="">
                                <img class="certificate_img" :src="imgItem.furl" alt="">
                            </div>
                            <Upload2  v-if="eduFormData.eduimageinfp.length < 5" class="avatar-uploader" :imgRule="imgRule" @setImage="setCCoverfile2" :uploadType="uploadType" ref="coverfile2"></Upload2>
                        </div>
                    </div>
                    <div class="btn_div">
                        <el-button type="primary" @click="eduInfoEditSureBtn" size="small">确定</el-button>
                        <el-button plain size="small" @click="cancelEditEdu(item)">取消</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="resume_item_box">
        <div class="title_box">
            <div class="title_left_box">
                <img :src="require('@/common/images/talentsimg/cicon5.png')" alt="">
                <span>自我评价</span>
            </div>
            <div class="title_right_box" @click="editClick(6)" v-show="!isEdit && resumeData.fullrate > 0">
                <img :src="require('@/common/images/talentsimg/aicon_edit.png')" alt="">
                <span>编辑</span>
            </div>
            <div class="title_right_box gray_style" v-show="isEdit || resumeData.fullrate === 0">
                <img :src="require('@/common/images/talentsimg/aicon_edit2.png')" alt="">
                <span>编辑</span>
            </div>
        </div>
        <div v-show="!(isEdit && editFromNo === 6)" class="self_evaluation_box">{{resumeData.baseinfo.selfevaluation}}</div>
    </div>
    <div class="self_evaluation_edit_box" v-show="isEdit && editFromNo === 6">
        <div class="textarea_div">
            <p>自我评价</p>
            <el-input type="textarea" :rows="4" placeholder="请填写自我评价，最多300个字。" v-model="selfevaluation" maxlength="300"></el-input>
        </div>
        <div class="btn_div">
            <el-button type="primary" size="small" @click="editSelfEvaInfo">确定</el-button>
            <el-button plain size="small" @click="editCancelBtn">取消</el-button>
        </div>
    </div>
</div>
</template>

<script>
import {getResumeAllInfo, saveOrUpdateResumInfo, updatePurposeInfo, updateSelfevaluation, saveOrUpdateWorkExe, saveOrUpdateProjectInfo, saveOrUpdateEduInfo, deleteRelatedInfo} from 'api/talentApi'
import {mapGetters, mapActions} from 'vuex'
import Upload from './upload'
import Upload2 from './upload2'
export default {
    name: 'ResumeEdit',
    data() {
        return {
            isEdit: false,
            editFromNo: 0,
            resumeData: {
                baseinfo: {
                    customericonurl: {
                        furl: ''
                    }
                },
                conpanyinfolist: [],
                projectinfolist: [],
                eduinfolist: []
            },
            userFromData: {
                innerid: '',
                customericonurl: '',
                name: '',
                sex: '',
                birth: '',
                domplace: '',
                nativeplace: '',
                mobileno: '',
                email: '',
                edutype: '',
                exptype: '',
                jobstatus: '',
                currentsalary: ''
            },
            sexOptions: [
                {
                    value: 1,
                    label: '男'
                }, {
                    value: 2,
                    label: '女'
                }
            ],
            educationOptions: [
                {
                    value: 1,
                    label: '本科'
                }, {
                    value: 2,
                    label: '硕士'
                }, {
                    value: 3,
                    label: '博士'
                }
            ],
            workYearsOptions: [
                {
                    value: 1,
                    label: '1~3年'
                }, {
                    value: 2,
                    label: '3-5年'
                }, {
                    value: 3,
                    label: '5-10年'
                }, {
                    value: 4,
                    label: '10年以上'
                }
            ],
            workStatusOptions: [
                {
                    value: 1,
                    label: '在岗'
                }, {
                    value: 2,
                    label: '已离职'
                }, {
                    value: 3,
                    label: '随时到岗'
                }
            ],
            objectiveFromData: {
                innerid: '',
                wishindustry: '',
                wishjobname: '',
                wishplace: '',
                wishsalary: '',
                wishsalarymax: ''
            },
            placeOptions: [
                {
                    value: '北京',
                    label: '北京'
                }, {
                    value: '上海',
                    label: '上海'
                }, {
                    value: '广州',
                    label: '广州'
                }, {
                    value: '深圳',
                    label: '深圳'
                }, {
                    value: '成都',
                    label: '成都'
                }, {
                    value: '杭州',
                    label: '杭州'
                }, {
                    value: '苏州',
                    label: '苏州'
                }, {
                    value: '东莞',
                    label: '东莞'
                }, {
                    value: '佛山',
                    label: '佛山'
                }, {
                    value: '武汉',
                    label: '武汉'
                }, {
                    value: '长沙',
                    label: '长沙'
                }, {
                    value: '重庆',
                    label: '重庆'
                }
            ],
            workExperienceForm: {
                innerid: '',
                resumeinnerid: '',
                companyname: '',
                industryname: '',
                jobbegin: '',
                jobend: '',
                jobname: '',
                jobinfo: '',
                istoday: false
            },
            projectFormData: {
                innerid: '',
                resumeinnerid: '',
                projectname: '',
                dutyname: '',
                projectbegin: '',
                projectend: '',
                projectduty: '',
                projectexpinfo: '',
                projectinfo: '',
                istoday: false
            },
            eduFormData: {
                innerid: '',
                resumeinnerid: '',
                eduname: '',
                majorname: '',
                edubegin: '', 
                eduend: '',
                edulevel: '',
                eduimageinfp: [],
                istoday: false
            },
            checked: true,
            textarea: '',
            selfevaluation: '',
            uploadType: {
                catecode: '102',
                datatype: 'IMAGE'
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 2,
                width: '',
                height: ''
            },
        }
    },
    mounted() {
        this.findResumeAllInfo()
    },
    methods: {
        findResumeAllInfo() {
            this.setLoading(true)
            var params = {}
            getResumeAllInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.resumeData = data.data
                    this.$emit('getProgress', this.resumeData.fullrate, this.resumeData.baseinfo.innerid)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        editClick(val) {
            this.isEdit = true
            this.editFromNo = val
            if (val === 1) {
                if (this.resumeData.baseinfo.customericonurl.furl === '') {
                    if (this.resumeData.baseinfo.sex === 2) {
                        this.$refs.coverfile.setImage(require('@/common/images/talentsimg/default_user2.png'))
                    } else {
                        this.$refs.coverfile.setImage(require('@/common/images/talentsimg/default_user.png'))
                    }
                } else {
                    this.$refs.coverfile.setImage(this.resumeData.baseinfo.customericonurl.furl)
                }
                this.userFromData.customericonurl = JSON.stringify(this.resumeData.baseinfo.customericonurl)
                if (this.resumeData.baseinfo.name !== '') {
                    this.userFromData.innerid = this.resumeData.baseinfo.innerid
                    this.userFromData.name = this.resumeData.baseinfo.name
                    this.userFromData.sex = this.resumeData.baseinfo.sex
                    this.userFromData.birth = this.resumeData.baseinfo.birth
                    this.userFromData.domplace = this.resumeData.baseinfo.domplace
                    this.userFromData.nativeplace = this.resumeData.baseinfo.nativeplace
                    this.userFromData.mobileno = this.resumeData.baseinfo.mobileno
                    this.userFromData.email = this.resumeData.baseinfo.email
                    this.userFromData.edutype = this.resumeData.baseinfo.edutype
                    this.userFromData.exptype = this.resumeData.baseinfo.exptype
                    this.userFromData.jobstatus = this.resumeData.baseinfo.jobstatus
                    this.userFromData.currentsalary = this.resumeData.baseinfo.currentsalary
                }
            }
            if (val === 2) {
                this.objectiveFromData.wishindustry = this.resumeData.baseinfo.wishindustry
                this.objectiveFromData.wishjobname = this.resumeData.baseinfo.wishjobname
                this.objectiveFromData.wishplace = this.resumeData.baseinfo.wishplace
                this.objectiveFromData.wishsalary = this.resumeData.baseinfo.wishsalary
                this.objectiveFromData.wishsalarymax = this.resumeData.baseinfo.wishsalarymax
            }
            if (val === 6) {
                this.selfevaluation = this.resumeData.baseinfo.selfevaluation
            }
        },
        editCancelBtn(val) {
            this.isEdit = false
            this.editFromNo = 0
            if (val === 1) {
                this.userFromData = {
                    customericonurl: '',
                    name: '',
                    sex: '',
                    birth: '',
                    domplace: '',
                    nativeplace: '',
                    mobileno: '',
                    email: '',
                    edutype: '',
                    exptype: '',
                    jobstatus: '',
                    currentsalary: ''
                }
                this.userFromData.customericonurl = this.resumeData.baseinfo.customericonurl.furl
            }
            if (val === 2) {
                this.objectiveFromData = {
                    innerid: '',
                    wishindustry: '',
                    wishjobname: '',
                    wishplace: '',
                    wishsalary: '',
                    wishsalarymax: ''
                }
            }
            if (val === 3) {
                this.workExperienceForm = {
                    innerid: '',
                    resumeinnerid: '',
                    companyname: '',
                    industryname: '',
                    jobbegin: '',
                    jobend: '',
                    jobname: '',
                    jobinfo: '',
                    istoday: false
                }
            }
            if (val === 4) {
                this.projectFormData = {
                    innerid: '',
                    resumeinnerid: '',
                    projectname: '',
                    dutyname: '',
                    projectbegin: '',
                    projectend: '',
                    projectduty: '',
                    projectexpinfo: '',
                    projectinfo: ''
                }
            }
            if (val === 6) {
                this.selfevaluation = ''
            }
        },
        editWorkExperience(item) {
            console.log(item)
            item.isEdit = true

            this.workExperienceForm.innerid = item.innerid
            this.workExperienceForm.resumeinnerid = item.resumeinnerid
            this.workExperienceForm.companyname = item.companyname
            this.workExperienceForm.industryname = item.industryname
            this.workExperienceForm.istoday = item.istoday
            this.workExperienceForm.jobbegin = item.jobbegin
            this.workExperienceForm.jobend = item.jobend
            this.workExperienceForm.jobname = item.jobname
            this.workExperienceForm.jobinfo = item.jobinfo

            this.isEdit = true
        },
        delWorkExperience(item) {
            this.$confirm('确定删除工作经历？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.delInfo(item.innerid, 1)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        cancelEditWorkExperience(item) {
            console.log(item)
            item.isEdit = false
            this.workExperienceForm = {
                innerid: '',
                resumeinnerid: '',
                companyname: '',
                industryname: '',
                jobbegin: '',
                jobend: '',
                jobname: '', 
                jobinfo: '',
                istoday: false
            }
            this.isEdit = false
        },
        editProjectEdit(item) {
            console.log(item)
            item.isEdit = true

            this.projectFormData.innerid = item.innerid
            this.projectFormData.resumeinnerid = item.resumeinnerid
            this.projectFormData.projectname = item.projectname
            this.projectFormData.dutyname = item.dutyname
            this.projectFormData.projectbegin = item.projectbegin
            this.projectFormData.projectend = item.projectend
            this.projectFormData.projectduty = item.projectduty
            this.projectFormData.projectexpinfo = item.projectexpinfo
            this.projectFormData.projectinfo = item.projectinfo
            this.projectFormData.istoday = item.istoday

            this.isEdit = true
        },
        delProjectEdit(item) {
            this.$confirm('确定删除项目经历？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.delInfo(item.innerid, 2)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        cancelEditProject(item) {
            item.isEdit = false
            this.projectFormData = {
                innerid: '',
                resumeinnerid: '',
                projectname: '',
                dutyname: '',
                projectbegin: '',
                projectend: '',
                projectduty: '',
                projectexpinfo: '',
                projectinfo: '',
                istoday: false
            }
            this.isEdit = false
        },
        eduEdit(item) {
            item.isEdit = true
            this.eduFormData.innerid = item.innerid
            this.eduFormData.resumeinnerid = item.resumeinnerid
            this.eduFormData.eduname = item.eduname
            this.eduFormData.majorname = item.majorname
            this.eduFormData.edubegin = item.edubegin
            this.eduFormData.eduend = item.eduend
            this.eduFormData.edulevel = item.edulevel
            this.eduFormData.eduimageinfp = item.eduimageinfp
            this.eduFormData.istoday = item.istoday
            this.isEdit = true
        },
        delEdit(item) {
            this.$confirm('确定删除教育经历？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.delInfo(item.innerid, 3)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        cancelEditEdu(item) {
            item.isEdit = false
            this.eduFormData = {
                innerid: '',
                resumeinnerid: '',
                eduname: '',
                majorname: '',
                edubegin: '',
                eduend: '',
                edulevel: '',
                eduimageinfp: [],
                istoday: false
            }
            this.isEdit = false
        },
        delInfo(id, type) {
            this.setLoading(true)
            var params = {
                objinnerid: id,
                deletetype: type,
            }
            deleteRelatedInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.findResumeAllInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        userInfoEditSureBtn() {
            if (this.userFromData.name === '') {
                this.$message.error('请填写姓名')
                return
            }
            if (this.userFromData.sex === '') {
                this.$message.error('请选择性别')
                return
            }
            if (this.userFromData.birth === '') {
                this.$message.error('请选择出生日期')
                return
            }
            if (this.userFromData.domplace === '') {
                this.$message.error('请填写居住地址')
                return
            }
            if (this.userFromData.nativeplace === '') {
                this.$message.error('请填写籍贯')
                return
            }
            if (this.userFromData.mobileno === '') {
                this.$message.error('请填写手机号码')
                return
            }
            if(!(/^1[3456789]\d{9}$/.test(this.userFromData.mobileno))){
                this.$message.error('请填写正确的手机号码')
                return
            }
            if (this.userFromData.email === '') {
                this.$message.error('请填写电子邮箱')
                return
            }
            var reg = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/
            if(!reg.test(this.userFromData.email)){
                this.$message.error('请填写正确的电子邮箱')
                return
            }
            if (this.userFromData.edutype === '') {
                this.$message.error('请选择学历')
                return
            }
            if (this.userFromData.exptype === '') {
                this.$message.error('请选择工作年限')
                return
            }
            if (this.userFromData.jobstatus === '') {
                this.$message.error('请选择工作状态')
                return
            }
            if (this.userFromData.currentsalary === '') {
                this.$message.error('请填写目前年薪')
                return
            }
            if (this.userFromData.currentsalary < 0) {
                this.$message.error('目前年薪不能为负')
                return
            }
            var regPos = /^\d+(\.\d+)?$/
            var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
            if(!(regPos.test(this.userFromData.currentsalary) || regNeg.test(this.userFromData.currentsalary))){
                this.$message.error('目前年薪请输入数字')
                return
            }
            var integer = /^[1-9]*[1-9][0-9]*$/
            if (!integer.test(this.userFromData.currentsalary)) {
                this.$message.error('目前年薪请输入正整数')
                return
            }
            this.setLoading(true)
            var params = this.userFromData
            saveOrUpdateResumInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.isEdit = false
                    this.editFromNo = 0
                    this.findResumeAllInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        objectiveSureBtn() {
            if (this.objectiveFromData.wishindustry === '') {
                this.$message.error('请填写期望行业')
                return
            }
            if (this.objectiveFromData.wishjobname === '') {
                this.$message.error('请填写期望职位')
                return
            }
            if (this.objectiveFromData.wishplace === '') {
                this.$message.error('请选择期望地点')
                return
            }
            if (this.objectiveFromData.wishsalary === '') {
                this.$message.error('请填写期望最少年薪')
                return
            }



            if (this.objectiveFromData.wishsalary < 0) {
                this.$message.error('期望最少年薪不能为负')
                return
            }
            var regPos = /^\d+(\.\d+)?$/
            var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
            if(!(regPos.test(this.objectiveFromData.wishsalary) || regNeg.test(this.objectiveFromData.wishsalary))){
                this.$message.error('期望最少年薪请输入数字')
                return
            }
            var integer = /^[1-9]*[1-9][0-9]*$/
            if (!(parseInt(this.objectiveFromData.wishsalary) === 0)) {
                if (!integer.test(this.objectiveFromData.wishsalary)) {
                    this.$message.error('期望最少年薪请输入正整数')
                    return
                }
            }
            if (this.objectiveFromData.wishsalarymax === '') {
                this.$message.error('请填写期望最多年薪')
                return
            }
            if (this.objectiveFromData.wishsalarymax < 0) {
                this.$message.error('期望最多年薪不能为负')
                return
            }
            if(!(regPos.test(this.objectiveFromData.wishsalarymax) || regNeg.test(this.objectiveFromData.wishsalarymax))){
                this.$message.error('期望最多年薪请输入数字')
                return
            }
            if (!(parseInt(this.objectiveFromData.wishsalarymax) === 0)) {
                if (!integer.test(this.objectiveFromData.wishsalarymax)) {
                    this.$message.error('期望最多年薪请输入正整数')
                    return
                }
            }

            if (parseInt(this.objectiveFromData.wishsalary) > parseInt(this.objectiveFromData.wishsalarymax)) {
                this.$message.error('期望最少年薪不能大于期望最多年薪')
                return
            }

            this.objectiveFromData.innerid = this.resumeData.baseinfo.innerid
            this.setLoading(true)
            var params = this.objectiveFromData
            updatePurposeInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.isEdit = false
                    this.editFromNo = 0
                    this.findResumeAllInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        workExperienceSureBtn() {
            if (this.workExperienceForm.companyname === '') {
                this.$message.error('请填写公司名称')
                return
            }
            if (this.workExperienceForm.industryname === '') {
                this.$message.error('请填写所在行业')
                return
            }
            if (this.workExperienceForm.jobbegin === null) {
                this.workExperienceForm.jobbegin = ''
            }
            this.workExperienceForm.jobbegin = this.workExperienceForm.jobbegin.replace('-','')
            if (this.workExperienceForm.jobbegin === '') {
                this.$message.error('请选择任职开始时间')
                return
            }
            if (this.workExperienceForm.jobend === null) {
                this.workExperienceForm.jobend = ''
            }
            if (this.workExperienceForm.jobend !== 0) {
                this.workExperienceForm.jobend = this.workExperienceForm.jobend.replace('-','')
            }
            if (this.workExperienceForm.istoday) {
                this.workExperienceForm.jobend = 0
            }
            if (this.workExperienceForm.jobend === '') {
                this.$message.error('请选择任职结束时间')
                return
            }
            if (this.workExperienceForm.jobend > 0) {
                if (parseInt(this.workExperienceForm.jobbegin) > parseInt(this.workExperienceForm.jobend)) {
                    this.$message.error('任职结束时间必须大于任职开始时间')
                    return
                }
            }
            if (this.workExperienceForm.jobname === '') {
                this.$message.error('请填写岗位名称')
                return
            }
            this.workExperienceForm.resumeinnerid = this.resumeData.baseinfo.innerid
            this.setLoading(true)
            var params = this.workExperienceForm
            saveOrUpdateWorkExe({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.isEdit = false
                    this.editFromNo = 0
                    this.workExperienceForm = {
                        innerid: '',
                        resumeinnerid: '',
                        companyname: '',
                        industryname: '',
                        jobbegin: '',
                        jobend: '',
                        jobname: '',
                        jobinfo: '',
                        istoday: false
                    }
                    this.findResumeAllInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        projectEditSureBtn() {
            console.log(this.projectFormData)
            if (this.projectFormData.projectname === '') {
                this.$message.error('请填写项目名称')
                return
            }
            if (this.projectFormData.dutyname === '') {
                this.$message.error('请填写担任职务')
                return
            }
            if (this.projectFormData.projectbegin === null) {
                this.projectFormData.projectbegin = ''
            }
            this.projectFormData.projectbegin = this.projectFormData.projectbegin.replace('-','')
            if (this.projectFormData.projectbegin === '') {
                this.$message.error('请选择项目开始时间')
                return
            }
            if (this.projectFormData.projectend === null) {
                this.projectFormData.projectend = ''
            }
            if (this.projectFormData.projectend !== 0) {
                this.projectFormData.projectend = this.projectFormData.projectend.replace('-','')
            }
            if (this.projectFormData.istoday) {
                this.projectFormData.projectend = 0
            }
            if (this.projectFormData.projectend === '') {
                this.$message.error('请选择项目结束时间')
                return
            }
            if (this.projectFormData.projectend > 0) {
                if (parseInt(this.projectFormData.projectbegin) > parseInt(this.projectFormData.projectend)) {
                    this.$message.error('项目结束时间必须大于项目开始时间')
                    return
                }
            }
            if (this.projectFormData.projectduty === '') {
                this.$message.error('请填写项目职责')
                return
            }
            if (this.projectFormData.projectinfo === '') {
                this.$message.error('请填写项目描述')
                return
            }
            this.projectFormData.resumeinnerid = this.resumeData.baseinfo.innerid
            this.setLoading(true)
            var params = this.projectFormData
            saveOrUpdateProjectInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.isEdit = false
                    this.editFromNo = 0
                    this.projectFormData = {
                        innerid: '',
                        resumeinnerid: '',
                        projectname: '',
                        dutyname: '',
                        projectbegin: '',
                        projectend: '',
                        projectduty: '',
                        projectexpinfo: '',
                        projectinfo: '',
                        istoday: false
                    }
                    this.findResumeAllInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        eduInfoEditSureBtn() {
            console.log(this.eduFormData)
            if (this.eduFormData.edubegin === null) {
                this.eduFormData.edubegin = ''
            }
            this.eduFormData.edubegin = this.eduFormData.edubegin.replace('-','')
            if (this.eduFormData.edubegin === '') {
                this.$message.error('请选择就读开始时间')
                return
            }
            if (this.eduFormData.eduend === null) {
                this.eduFormData.eduend = ''
            }
            if (this.eduFormData.eduend !== 0) {
                this.eduFormData.eduend = this.eduFormData.eduend.replace('-','')
            }
            if (this.eduFormData.istoday) {
                this.eduFormData.eduend = 0
            }
            if (this.eduFormData.eduend === '') {
                this.$message.error('请选择就读结束时间')
                return
            }
            if (this.eduFormData.eduend > 0) {
                if (parseInt(this.eduFormData.edubegin) > parseInt(this.eduFormData.eduend)) {
                    this.$message.error('就读结束时间必须大于就读开始时间')
                    return
                }
            }
            if (this.eduFormData.eduname === '') {
                this.$message.error('请填写学校名称')
                return
            }
            if (this.eduFormData.majorname === '') {
                this.$message.error('请填写专业名称')
                return
            }
            if (this.eduFormData.edulevel === '') {
                this.$message.error('请选择学历证书')
                return
            }
            this.setLoading(true)
            var params = {
                innerid: this.eduFormData.innerid,
                resumeinnerid: this.eduFormData.resumeinnerid,
                eduname: this.eduFormData.eduname,
                majorname: this.eduFormData.majorname,
                edubegin: this.eduFormData.edubegin,
                eduend: this.eduFormData.eduend,
                edulevel: this.eduFormData.edulevel,
                eduimageinfp: JSON.stringify(this.eduFormData.eduimageinfp)
            }
            if (this.eduFormData.eduimageinfp.length === 0) {
                params.eduimageinfp = ''
            }
            params.resumeinnerid = this.resumeData.baseinfo.innerid
            saveOrUpdateEduInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.isEdit = false
                    this.editFromNo = 0
                    this.eduFormData = {
                        innerid: '',
                        resumeinnerid: '',
                        eduname: '',
                        majorname: '',
                        edubegin: '',
                        eduend: '',
                        edulevel: '',
                        eduimageinfp: [],
                        istoday: false
                    }
                    this.findResumeAllInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        editSelfEvaInfo() {
            var params = {
                innerid: this.resumeData.baseinfo.innerid,
                selfevaluation: this.selfevaluation
            }
            updateSelfevaluation({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.isEdit = false
                    this.editFromNo = 0
                    this.findResumeAllInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        workEndTimeChange() {
            if (this.workExperienceForm.istoday) {
                this.workExperienceForm.jobend = 0
            } else {
                this.workExperienceForm.jobend = ''
            }
        },
        projectEndTimeChange() {
            if (this.projectFormData.istoday) {
                this.projectFormData.projectend = 0
            } else {
                this.projectFormData.projectend = ''
            }
        },
        eduEndTimeChange() {
            if (this.eduFormData.istoday) {
                this.eduFormData.eduend = 0
            } else {
                this.eduFormData.eduend = ''
            }
        },
        setCCoverfile(list) {
            delete list.type
            this.userFromData.customericonurl = JSON.stringify(list)
        },
        setCCoverfile2(list) {
            delete list.type
            this.eduFormData.eduimageinfp.push(list)
        },
        delImg(index) {
            this.eduFormData.eduimageinfp.splice(index, 1)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        Upload,
        Upload2
    }
}
</script>

<style lang="scss" type="text/scss">
.ResumeEdit {
    padding-bottom: 60px;
    .personal_info_box {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        .info_left_div {
            padding-top: 10px;
            display: flex;
            &>img {
                width: 120px;
                height: 120px;
                margin-right: 30px;
                border-radius: 60px;
            }
            .info_div {
                &>p {
                    color: #333;
                    font-size: 20px;
                    line-height:28px;
                    font-weight: bold;
                }
                &>div {
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    &>img {
                        width: 16px;
                        height: 16px;
                        margin-right: 10px;
                    }
                    &>span {
                        color: #666;
                        font-size: 14px;
                        line-height: 20px;
                    }
                    span+span {
                        margin-left: 15px;
                    }
                }
                .contact_info_div {
                    &>span {
                        min-width: 105px;
                    }
                }
            }
        }
        .info_right_div {
            .edit_div {
                display: flex;
                align-items: center;
                cursor: pointer;
                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;
                }
                span {
                    color: #2E7FFF;
                    line-height:20px;
                }
            }
            .gray_style {
                span {
                    color: #999;
                }
            }
        }
    }
    .personal_info_form_box {
        margin-top: 26px;
        border:2px solid rgba(46,127,255,1);
        padding: 20px;
        box-sizing: border-box;
        .personal_info_div {
            display: flex;
            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 50%;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader {
                width: 120px;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 120px;
                height: 120px;
                line-height: 120px;
                text-align: center;
            }
            .avatar {
                width: 120px;
                height: 120px;
                display: block;
            }
            .form_div {
                margin-left: 40px;
                .form_item_div {
                    display: flex;
                    &>div {
                        display: flex;
                        align-items: center;
                        &>p {
                            width: 68px;
                            text-align: right;
                            line-height: 20px;
                            margin-right: 10px;
                            span {
                                color: #F56C6C;
                            }
                        }
                        .el-input__icon {
                            line-height: 36px;
                        }
                        .el-input {
                            width: 224px;
                        }
                        .el-input__inner {
                            height: 36px;
                            line-height: 36px;
                        }
                    }
                    &>div:nth-of-type(2) {
                        margin-left: 50px;
                    }
                    .suffix_input_box {
                        .el-input--suffix .el-input__inner {
                            padding-right: 38px;
                        }
                    }
                }
                .form_item_div + .form_item_div {
                    margin-top: 12px;
                }
            }
        }
        .btn_div {
            margin-top: 30px;
            display: flex;
            justify-content: center;
            .el-button {
                width: 95px;
                font-size: 14px;
            }
            .el-button+.el-button {
                margin-left: 20px;
            }
        }
    }
    .Job_Intension_edit_box {
        margin-top: 26px;
        border:2px solid rgba(46,127,255,1);
        padding: 20px 80px;
        box-sizing: border-box;
        .Job_Intension_edit_row {
            display: flex;
            align-items: center;
            &>p {
                width: 68px;
                min-width: 68px;
                text-align: right;
                line-height: 20px;
                margin-right: 10px;
                white-space: nowrap;
                span {
                    color: #F56C6C;
                }
            }
            .el-input__icon {
                line-height: 36px;
            }
            .el-input__inner {
                height: 36px;
                line-height: 36px;
            }
        }
        .certificate_box {
            align-items: flex-start;
            &>p {
                padding-top: 8px;
            }
            .certificate_div {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                .certificate_img_box {
                    margin-right: 15px;
                    position: relative;
                    width: 110px;
                    height: 110px;
                    .del_img {
                        position: absolute;
                        top: -5px;
                        right: -5px;
                        width: 16px;
                        height: 16px;
                        cursor: pointer;
                    }
                    .certificate_img {
                        width: 110px;
                        height: 110px;
                    }
                }
                .avatar-uploader {
                    width: 110px;
                    height: 110px;
                }
                .avatar-uploader-icon {
                    height: 110px;
                    line-height: 110px;
                    text-align: center;
                }
            }
        }
        .suffix_input_box {
            &>label {
                margin: 0 15px;
                color: #909399;
            }
            .el-input--suffix .el-input__inner {
                padding-right: 38px;
            }
        }
        .Job_Intension_edit_row + .Job_Intension_edit_row {
            margin-top: 12px;
        }
        .textarea_input_div {
            align-items: flex-start;
            &>p {
                margin-top: 8px;
            }
        }
        .btn_div {
            margin-top: 30px;
            display: flex;
            justify-content: center;
            .el-button {
                width: 95px;
                font-size: 14px;
            }
            .el-button+.el-button {
                margin-left: 20px;
            }
        }
    }
    .resume_item_box {
        margin-top: 40px;
        .title_box {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            .title_left_box {
                display: flex;
                align-items: center;
                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 6px;
                }
                span {
                    color: #333;
                    font-size: 18px;
                    line-height:26px;
                    font-weight: bold;
                }
            }
            .title_right_box {
                display: flex;
                align-items: center;
                cursor: pointer;
                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;
                }
                span {
                    color: #2E7FFF;
                    line-height:20px;
                }
            }
            .gray_style {
                span {
                    color: #999;
                }
            }
        }
        .Job_Intension_info_box {
            .Job_Intension_row_div {
                line-height: 20px;
                label {
                    color: #999;
                }
                span {
                    color: #666;
                }
            }
            .Job_Intension_row_div + .Job_Intension_row_div {
                margin-top: 10px;
            }
        }
        .occupational_history_box, .Project_experience_box {
            .occupational_history_item_box, .Project_experience_item_box {
                .content_div {
                    box-sizing: border-box;
                    padding: 20px 10px;
                    line-height: 20px;
                }
                .handle_box {
                    display: flex;
                    justify-content: space-between;
                    .time_info {
                        line-height: 20px;
                    }
                    .handle_div {
                        display: none;
                        &>div {
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            margin-left: 20px;
                            img {
                                width: 16px;
                                height: 16px;
                                margin-right: 6px;
                            }
                            span {
                                color: #2E7FFF;
                            }
                        }
                        &>div + &>div {
                            margin-left: 20px;
                        }
                    }
                    .gray_div {
                        &>div {
                            span {
                                color: #999;
                            }
                        }
                    }
                }
                .company_name_text {
                    font-weight: bold;
                    line-height: 20px;
                }
                .job_info_div {
                    line-height: 20px;
                    span {
                        color: #999;
                    }
                    span + span {
                        margin-left: 15px;
                    }
                }
                .job_desc_div {
                    line-height: 24px;
                    color: #666;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
                .Project_desc_row_div {
                    display: flex;
                    p:nth-of-type(1) {
                        white-space: nowrap;
                        color: #999;
                    }
                    .p_desc_text {
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    .p_desc_text2 {
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        line-clamp: 3;
                        -webkit-box-orient: vertical;
                    }
                }
                .occupational_history_item_row_div + .occupational_history_item_row_div {
                    margin-top: 10px;
                }
                .Project_experience_item_row_div + .Project_experience_item_row_div {
                    margin-top: 10px;
                }
            }
            .occupational_history_item_box + .occupational_history_item_box {
                border-top: 1px solid #e5e5e5;
            }
            .Project_experience_item_box + .Project_experience_item_box {
                border-top: 1px solid #e5e5e5;
            }
            .occupational_history_item_box:hover, .Project_experience_item_box:hover {
                .content_div {
                    border: 1px solid #2E7FFF;
                    padding: 19px 8px;
                }
                .handle_box {
                    .handle_div {
                        display: flex;
                    }
                }
            }
        }
        .edu_experience_box {
            .edu_experience_item_box {
                .content_div {
                    height: 60px;
                    display: flex;
                    .edu_row_div + .edu_row_div {
                        margin-left: 35px;
                    }
                    .edu_time {
                        line-height: 60px;
                        width: 150px;
                    }
                    .school_name, .profession_name {
                        line-height: 60px;
                        width: 240px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    .profession_name {
                        width: 130px;
                    }
                    .education_background {
                        line-height: 60px;
                        margin-right: 100px;
                    }
                    .handle_div {
                        display: none;
                        &>div {
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            margin-left: 20px;
                            img {
                                width: 16px;
                                height: 16px;
                                margin-right: 6px;
                            }
                            span {
                                color: #2E7FFF;
                            }
                        }
                        &>div + &>div {
                            margin-left: 20px;
                        }
                    }
                    .gray_div {
                        &>div {
                            span {
                                color: #999;
                            }
                        }
                    }
                }
            }
            .edu_experience_item_box:hover {
                .content_div {
                    border: 1px solid #2E7FFF!important;
                    .handle_div {
                        display: flex;
                    }
                }
            }
            .edu_experience_item_box + .edu_experience_item_box {
                border-top: 1px solid #e5e5e5;
            }
        }
        .self_evaluation_box {
            line-height:24px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
        }
    }
    .resume_item_box:nth-of-type(1) {
        margin-top: 50px;
    }
    .self_evaluation_edit_box {
        margin-top: 26px;
        border:2px solid rgba(46,127,255,1);
        padding: 20px 0;
        box-sizing: border-box;
        .textarea_div {
            display: flex;
            padding-right: 80px;
            padding-left: 92px;
            padding-bottom: 30px;
            &>p {
                white-space: nowrap;
                margin-right: 10px;
                line-height: 20px;
                padding-top: 8px;
                font-size:14px;
            }
        }
        .btn_div {
            display: flex;
            justify-content: center;
            .el-button {
                width: 95px;
                font-size: 14px;
            }
            .el-button+.el-button {
                margin-left: 20px;
            }
        }
    }
}
</style>